// extracted by mini-css-extract-plugin
export default {"Container":"links_Container__4Gaer","Status-active":"links_Status-active__-pSwJ","Status-inactive":"links_Status-inactive__3HHzf","balance":"links_balance__BCX+K"};